<template>
  <div class="filter-secs">
    <div class="filter-heading">
      <h3>Filters</h3>
      <a href="#" @click.prevent="cleareAllFilters()" title>Clear all filters</a>
    </div>
    <!--filter-heading end-->
    <div class="paddy">
      <div class="filter-dd">
        <div class="filter-ttl">
          <h3>Location</h3>
          <a href="#" @click.prevent="suburbId=''" title>Clear</a>
        </div>
        <form class="job-tp">
          <suburb2 v-model="suburbId"></suburb2>
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </form>
      </div>
      <div class="filter-dd">
        <div class="filter-ttl">
          <h3>Category</h3>
          <a href="#" @click.prevent="categoryId=''" title>Clear</a>
        </div>
        <form class="job-tp">
          <category-finder v-model="categoryId"></category-finder>
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </form>
      </div>
      <div class="filter-dd">
        <div class="filter-ttl">
          <h3>Budget</h3>
          <a href="#" @click.prevent="budgetId=''" title>Clear</a>
        </div>
        <form class="job-tp">
          <budget2 v-model="budgetId"></budget2>
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Suburb2 from "./../../Suburb2";
import CategoryFinder from "./../../CategoryFinder";
import Budget2 from "./../../Budget2";
export default {
  name: "task-filter",
  components: {
    Suburb2,
    CategoryFinder,
    Budget2
  },
  props: {
    suburb_id: {
      type: [String, Number],
      default: null
    },
    category_id: {
      type: [String, Number],
      default: null
    },
    budget_id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      suburbId: this.suburb_id,
      categoryId: this.category_id,
      budgetId: this.budget_id
    };
  },
  methods: {
    onLocationInputChange(query) {
      if (query.trim().length === 0) {
        return null;
      }
      // return the matching countries as an array
      return this.subrubs.filter(country => {
        return country.toLowerCase().includes(query.toLowerCase());
      });
    },
    createSearchQuery() {
      let query = "";
      if (this.suburbId) {
        if (query == "") {
          query += "?suburb_id=" + this.suburbId;
        } else {
          query += "&suburb_id=" + this.suburbId;
        }
      }
      if (this.categoryId) {
        if (query == "") {
          query += "?category_id=" + this.categoryId;
        } else {
          query += "&category_id=" + this.categoryId;
        }
      }
      if (this.budgetId) {
        if (query == "") {
          query += "?budget_id=" + this.budgetId;
        } else {
          query += "&budget_id=" + this.budgetId;
        }
      }

      return query;
    },
    changeLocation() {
      if (this.suburb_id != this.suburbId) {
        this.$parent.loading = true
        axios.get('/ajax/task'+this.createSearchQuery()).then(res => {
          this.$parent.tasks = res.data.tasks.data
		  this.$parent.query = this.createSearchQuery()
		  this.$parent.loading = false
		  this.$parent.currentPage = 1
		  this.$parent.pages = res.data.tasks.last_page
        })
      }
      if (this.category_id != this.categoryId) {
        this.$parent.loading = true
        axios.get('/ajax/task'+this.createSearchQuery()).then(res => {
          this.$parent.tasks = res.data.tasks.data
		  this.$parent.query = this.createSearchQuery()
		  this.$parent.loading = false
		  this.$parent.currentPage = 1
		  this.$parent.pages = res.data.tasks.last_page
        })
      }
      if (this.budget_id != this.budgetId) {
        this.$parent.loading = true
        axios.get('/ajax/task'+this.createSearchQuery()).then(res => {
          this.$parent.tasks = res.data.tasks.data
		  this.$parent.query = this.createSearchQuery()
		  this.$parent.loading = false
		  this.$parent.currentPage = 1
		  this.$parent.pages = res.data.tasks.last_page
        })
      }
    },
    cleareAllFilters() {
      this.suburbId = this.categoryId = this.budgetId = null;
    }
  },
  watch: {
    suburbId: {
      handler() {
        this.changeLocation();
      }
    },
    categoryId: {
      handler() {
        this.changeLocation();
      }
    },
    budgetId: {
      handler() {
        this.changeLocation();
      }
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
